import {
  ConsultantAnalysisFilters,
  FiduciaryAnalysisFilters,
  FundAnalysisFilters,
  PaginatedParams,
  ProviderAnalysisFilters,
  SchemeAnalysisFilters,
  SubFundAnalysisFilters
} from './types';

export function getFundAnalysisUrl(
  props?: PaginatedParams<{
    filters?: FundAnalysisFilters;
  }>
): string {
  const urlParams = new URLSearchParams();
  const params = props?.filters;

  if (params?.parentId?.length) {
    params.parentId?.forEach(it => {
      urlParams.append('parentId[]', it);
    });
  }
  if (params?.parentInvestmentId?.length) {
    params.parentInvestmentId?.forEach(it => {
      urlParams.append('parentInvestmentId[]', it);
    });
  }

  if (params?.organizationIds?.length) {
    params.organizationIds?.forEach(it => {
      urlParams.append('organizationIds[]', it);
    });
  }

  if (params?.psEntityIds?.length) {
    params.psEntityIds.forEach(it => {
      urlParams.append('psEntityIds[]', it);
    });
  }

  if (params?.fundIds?.length) {
    params.fundIds.forEach(it => {
      urlParams.append('fundIds[]', it);
    });
  }

  if (params?.assetClassIds?.length) {
    params.assetClassIds.forEach(it => {
      urlParams.append('assetClassIds[]', it);
    });
  }

  if (params?.fundTypeIds?.length) {
    params.fundTypeIds.forEach(it => {
      urlParams.append('fundTypeIds[]', it);
    });
  }

  if (params?.assetManagerIds?.length) {
    params.assetManagerIds.forEach(it => {
      urlParams.append('assetManagerIds[]', it);
    });
  }

  if (params?.reportingPeriodIds?.length) {
    params?.reportingPeriodIds?.forEach(it => {
      urlParams.append('reportingPeriodIds[]', it);
    });
  }

  if (params?.sfEntityIds?.length) {
    params.sfEntityIds?.forEach(it => {
      urlParams.append('sfEntityIds[]', it);
    });
  }

  if (params?.templateIds?.length) {
    params.templateIds?.forEach(it => {
      urlParams.append('templateIds[]', it);
    });
  }
  if (params?.requestStartDate) {
    urlParams.set('requestStartDate', params?.requestStartDate?.toString());
  }

  if (params?.requestEndDate) {
    urlParams.set('requestEndDate', params?.requestEndDate?.toString());
  }

  if (params?.status) {
    urlParams.set('status', params.status.toString());
  }

  if (params?.investmentPeriodTags?.length) {
    params.investmentPeriodTags?.forEach(it => {
      urlParams.append('investmentPeriodTags[]', it);
    });
  }

  if (params?.annualizationTags?.length) {
    params.annualizationTags?.forEach(it => {
      urlParams.append('annualizationTags[]', it);
    });
  }

  if (params?.entityIds?.length) {
    params.entityIds?.forEach(it => {
      urlParams.append('entityIds[]', it);
    });
  }
  if (params?.includeUnderFund) {
    urlParams.set('includeUnderFund', params.includeUnderFund.toString());
  }
  if (params?.includeBenchmarking) {
    urlParams.set('includeBenchmarking', params.includeBenchmarking.toString());
  }
  if (params?.searchKeyword) {
    urlParams.set('searchKeyword', params.searchKeyword.toString());
  }
  if (params?.page) {
    urlParams.set('page', params.page.toString());
  }
  if (params?.limit) {
    urlParams.set('limit', params.limit.toString());
  }

  if (
    params?.overrideAumBasedRelativeValue !== null &&
    params?.overrideAumBasedRelativeValue !== undefined
  ) {
    urlParams.set(
      'overrideAumBasedRelativeValue',
      params?.overrideAumBasedRelativeValue?.toString()
    );
  }

  urlParams.set('currencyPreference', 'PREFERRED');
  return urlParams.toString();
}

export function getSchemeAnalysisUrlParams(
  params?: SchemeAnalysisFilters
): string {
  if (!params) {
    return '';
  }
  const urlParams = new URLSearchParams();
  if (params?.investmentIds?.length) {
    params.investmentIds?.forEach(it => {
      urlParams.append('investment_id[]', it);
    });
  }
  if (params?.entityIds?.length) {
    params.entityIds?.forEach(it => {
      urlParams.append('entity_id[]', it);
    });
  }
  if (params?.timePeriodIds?.length) {
    params.timePeriodIds?.forEach(it => {
      urlParams.append('time_period_id[]', it);
    });
  }
  if (params?.consultantIds?.length) {
    params.consultantIds.forEach(it => {
      urlParams.append('consultant_id[]', it);
    });
  }
  if (params?.schemeName) {
    urlParams.set('scheme_name', params.schemeName.toString());
  }
  if (params?.page) {
    urlParams.set('page', params?.page.toString());
  }
  if (params?.limit) {
    urlParams.set('limit', params?.limit.toString());
  }

  urlParams.set('includeBenchmarking', 'false');
  urlParams.set('currencyPreference', 'PREFERRED');

  return urlParams.toString();
}

export function getSubFundAnalysisUrlParams(
  params?: SubFundAnalysisFilters
): string {
  if (!params) {
    return '';
  }
  const urlParams = new URLSearchParams();
  if (params?.investmentIds?.length) {
    params.investmentIds?.forEach(it => {
      urlParams.append('investment_id[]', it);
    });
  }
  if (params?.entityIds?.length) {
    params.entityIds?.forEach(it => {
      urlParams.append('entity_id[]', it);
    });
  }
  if (params?.timePeriodIds?.length) {
    params.timePeriodIds?.forEach(it => {
      urlParams.append('time_period_id[]', it);
    });
  }
  if (params?.fiduciaryIds?.length) {
    params.fiduciaryIds.forEach(it => {
      urlParams.append('fiduciary_id[]', it);
    });
  }
  if (params?.subFundName) {
    urlParams.set('subfund_name', params.subFundName.toString());
  }
  if (params?.page) {
    urlParams.set('page', params?.page.toString());
  }
  if (params?.limit) {
    urlParams.set('limit', params?.limit.toString());
  }
  urlParams.set('currencyPreference', 'PREFERRED');

  return urlParams.toString();
}

export function getConsultantAnalysisUrlParams(
  params: ConsultantAnalysisFilters
): string {
  if (!params) {
    return '';
  }
  const urlParams = new URLSearchParams();
  if (params?.consultant_entity_id) {
    urlParams.set(
      'consultant_entity_id',
      params.consultant_entity_id.toString()
    );
  }
  if (params?.time_period_id) {
    urlParams.set('time_period_id', params.time_period_id.toString());
  }
  urlParams.set('currencyPreference', 'PREFERRED');
  return urlParams.toString();
}

export function getProviderUrlParams(params: ProviderAnalysisFilters): string {
  if (!params) {
    return '';
  }
  const urlParams = new URLSearchParams();
  if (params?.provider_entity_id) {
    urlParams.set('provider_entity_id', params.provider_entity_id.toString());
  }
  if (params?.time_period_id) {
    urlParams.set('time_period_id', params.time_period_id.toString());
  }
  urlParams.set('currencyPreference', 'PREFERRED');
  return urlParams.toString();
}

export function getFiduciaryAnalysisUrlParams(
  params: FiduciaryAnalysisFilters
): string {
  if (!params) {
    return '';
  }
  const urlParams = new URLSearchParams();
  if (params?.entity_id) {
    urlParams.set('entity_id', params.entity_id.toString());
  }
  if (params?.time_period_id) {
    urlParams.set('time_period_id', params.time_period_id.toString());
  }
  urlParams.set('currencyPreference', 'PREFERRED');
  return urlParams.toString();
}
